import { createSelector } from 'reselect'
import errorPageSelector from './errorPageSelector'

const showErrorPageSelector = createSelector(
    errorPageSelector,
    (data): boolean => data.show,
)

export default showErrorPageSelector
